module.exports = __webpack_public_path__ + "static/media/mongodb.11c47ac1.svg";